import { TextField } from '../../Inputs';
import type { ColumnFilterProps } from '../types';
import { useTableTexts } from '../useTableTexts';
import { getFilterInputProps } from './util';

export const DefaultColumnFilter = ({ column, layout }: ColumnFilterProps) => {
  const texts = useTableTexts();
  return (
    <TextField
      value={column.getFilterValue() || ''}
      name={column.id}
      onChange={(e) => {
        column.setFilterValue(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      {...getFilterInputProps(column, layout, texts)}
    />
  );
};
